import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import java_full_stack from '../components/assets/java1.png';
import makeup from '../components/assets/makeup.jpg';
import CIA from '../components/assets/CIA.webp';
import python_full_stack from '../components/assets/python.webp';
import ai_ml from '../components/assets/Aiml.webp';
import data_science from '../components/assets/Datascience.webp';
import cybersecurity from '../components/assets/cybersec.jpeg';
import cloud_devops from '../components/assets/cloud.jpeg';
import web_dev from '../components/assets/web.jpg';
import software_testing from '../components/assets/Testing.jpg';
import digital_marketing from '../components/assets/Digital Marketing.jpg';
import sap from '../components/assets/Sap.jpeg';
import mobile_repair from '../components/assets/mobile.jpg';
import tv_repair from '../components/assets/Tv.jpeg';
import system_repair from '../components/assets/system.jpg';

import Footer from '../components/Footer/Footer';
import './css/Courses.css';

import white_arrow from '../components/assets/white-arrow.png';
import mhAcademyLogo from '../components/assets/logo2.1.png';

const Course = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [category, setCategory] = useState('All');
  const [showModal, setShowModal] = useState(false);
  const [result, setResult] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const catParam = params.get('category');

    switch ((catParam || '').toLowerCase()) {
      case 'it':
      case 'it courses':
        setCategory('IT Courses');
        break;
      case 'financial':
      case 'financial courses':
        setCategory('Financial Courses');
        break;
      case 'skill':  // renamed from career
        setCategory('Skill Development');
        break;
      case 'beauty':
      case 'makeup':
      case 'makeup & hairstyle':
      case 'makeup & hairstyling':
        setCategory('Beauty Courses');
        break;
      default:
        setCategory('All');
        break;
    }
  }, [location.search]);

  const itCourses = [
    {
      id: 1,
      title: "Java Full Stack",
      description: "Master both frontend and backend development with Java, Spring Boot, Hibernate, REST APIs, React.js, and database integration. Perfect to become full-stack developers.",
      image: java_full_stack
    },
    {
      id: 2,
      title: "Python Full Stack",
      description: "Gain hands-on experience in Python development, Django, RESTful APIs, frontend technologies like React, and real-world deployment.",
      image: python_full_stack
    },
    {
      id: 3,
      title: "AI and ML",
      description: "Explore the core concepts of Artificial Intelligence and Machine Learning using Python, scikit-learn, and TensorFlow. Work on predictive models, neural networks, and AI-driven applications.",
      image: ai_ml
    },
    {
      id: 4,
      title: "Data Science",
      description: "Learn data analysis, visualization, statistics, and machine learning using tools like Pandas, NumPy, Matplotlib, and Python. Build your career as a data analyst or scientist.",
      image: data_science
    },
    {
      id: 5,
      title: "Cybersecurity",
      description: "Learn ethical hacking, penetration testing, cryptography, network security, and incident response. Get trained for cybersecurity certifications and industry roles.",
      image: cybersecurity
    },
    {
      id: 6,
      title: "Cloud & DevOps",
      description: "Understand cloud platforms (AWS, Azure), infrastructure automation, CI/CD pipelines, containerization with Docker & Kubernetes, and DevOps lifecycle management.",
      image: cloud_devops
    },
    {
      id: 7,
      title: "Web Development",
      description: "Master HTML, CSS, JavaScript, responsive design, frontend frameworks like React, and backend using Node.js and MongoDB. Build and deploy real websites.",
      image: web_dev
    },
    {
      id: 8,
      title: "Software Testing",
      description: "Learn manual testing techniques, test case design, automation testing using Selenium, test frameworks like TestNG, and bug tracking tools like JIRA.",
      image: software_testing
    }
  ];

  const financialCourses = [
    {
      id: 9,
      title: "Digital Marketing",
      description: "Learn SEO, SEM, social media marketing, content creation, email marketing, Google Analytics, and tools to run effective digital campaigns.",
      image: digital_marketing
    },
    {
      id: 10,
      title: "SAP",
      description: "Get trained on SAP FICO, SAP MM, SAP SD, and SAP HANA. Learn ERP fundamentals, configuration, and real-time business scenarios.",
      image: sap
    },
    
 {
  id: 14,
  title: "CIA",
  description: "Comprehensive training in Tally Prime, Zoho Books, GST/TDS, Income Tax, Advanced Excel, Business Accounting, and Payroll Management. Ideal for aspiring internal auditors, accountants, and finance professionals.",
  image: CIA
}


  ];

  // skill development courses (renamed from career courses)
  const skillDevelopmentCourses = [
    {
      id: 11,
      title: "Mobile Repair",
      description: "Get skilled in diagnosing and fixing mobile hardware/software issues, screen and battery replacement, flashing, rooting, and unlocking phones.",
      image: mobile_repair
    },
    {
      id: 12,
      title: "TV Repair",
      description: "Learn to repair LED, LCD, and Smart TVs by understanding power supply, display units, and circuit troubleshooting. Ideal for electronics technicians.",
      image: tv_repair
    },
    {
      id: 13,
      title: "System Repair",
      description: "Master desktop and laptop repair, including motherboard issues, RAM upgrades, OS installation, virus removal, and data recovery techniques.",
      image: system_repair
    }
  ];

  const beautyCourses = [
    {
      id: 15,
      title: "Makeup & Hairstyle",
      description: "Learn professional makeup artistry, bridal makeup, contouring, hairstyling techniques, product knowledge, and client consultation. Ideal for freelance artists and salon professionals.",
      image: makeup
    }
  ];

  const getCoursesToDisplay = () => {
    switch (category) {
      case 'IT Courses': return itCourses;
      case 'Financial Courses': return financialCourses;
      case 'Skill Development': return skillDevelopmentCourses;
      case 'Beauty Courses': return beautyCourses;
      default:
        return [...itCourses, ...financialCourses, ...skillDevelopmentCourses, ...beautyCourses];
    }
  };

  const handleExplore = (course) => {
    navigate(`/course/${course.id}`, { state: { course } });
  };

  const handleCategoryClick = (cat) => {
    setCategory(cat);

    let catParam = cat.toLowerCase();
    if (cat === 'All') catParam = '';
    else if (cat === 'IT Courses') catParam = 'it';
    else if (cat === 'Financial Courses') catParam = 'financial';
    else if (cat === 'Skill Development') catParam = 'skill ';
    else if (cat === 'Beauty Courses') catParam = 'beauty';

    navigate(`/courses${catParam ? `?category=${catParam}` : ''}`);
  };

  const handleEnroll = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setResult("Sending...");
    const formData = new FormData(e.target);
    formData.append("access_key", "c717ccdb-e8e5-4638-b9da-ba5a150b4b88");

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    }).then(res => res.json());

    setResult(res.success ? res.message : res.message);
    if (res.success) e.target.reset();
  };

  return (
    <>
      <div className="courses-section">
        <h2 className="courses-title">Our Courses</h2>
        <div className="courses-filters">
          {["All", "IT Courses", "Financial Courses", "Skill Development", "Beauty Courses"].map(cat => (
            <button
              key={cat}
              onClick={() => handleCategoryClick(cat)}
              className={`courses-filter-btn ${category === cat ? 'active' : ''}`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="courses-grid">
          {getCoursesToDisplay().map(course => (
            <div key={course.id} className="course-card">
              <img src={course.image} alt={course.title} className="course-img" />
              <div className="course-content">
                <h3>{course.title}</h3>
                <p>{course.description}</p>
                <div className="course-actions">
                  <button className="btn-explore" onClick={() => handleExplore(course)}>Explore</button>
                  <button className="btn-enroll" onClick={handleEnroll}>Enroll</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <button className="modal-close" onClick={handleCloseModal}>×</button>
            <img src={mhAcademyLogo} alt="Logo" className="modal-logo" />
            <form onSubmit={onSubmit}>
              <label>Your Name</label>
              <input type="text" name='name' required placeholder="Enter your name" />
              <label>Phone Number</label>
              <input type="tel" name='phone' required placeholder="Enter your phone number" />
              <label>Your Message</label>
              <textarea name="message" required placeholder="Enter your message" rows="4" />
              <button type="submit" className="submit-btn">
                Submit Now <img src={white_arrow} alt="arrow" />
              </button>
              <p className="modal-result">{result}</p>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Course;
